import { createContext } from 'react';

import type { CitationCardData } from './governing-document-sources';

/**
 * Threaded to `RelationshipCitation` through context, not a prop, because
 * Streamdown's `Block` is memoized on content alone: a context consumer inside
 * that memoized subtree still re-renders when the value changes, so badges pick
 * up a late-arriving map without remounting the markdown tree.
 */
export const CitationCardDataContext = createContext<
  ReadonlyMap<string, CitationCardData> | undefined
>(undefined);
